import { render } from "./submit-button.vue?vue&type=template&id=c64623a6"
import script from "./submit-button.vue?vue&type=script&lang=js"
export * from "./submit-button.vue?vue&type=script&lang=js"

import "./submit-button.vue?vue&type=style&index=0&id=c64623a6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__